import Controller from "./bulkBonuses.controller";
import template from "./bulkBonuses.html";

const bulkBonuses = {
  template,
  controller: Controller,
};

export default bulkBonuses;



// WEBPACK FOOTER //
// ./src/pages/bulkBonuses/bulkBonuses.component.js